<template>
  <el-dialog
    v-drag
    title="上传自留ISA"
    :visible.sync="dialogVisible"
    width="520px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <div class="upload">
        <el-upload
          class="upload-demo"
          drag
          action="#"
          list-type="picture"
          :http-request="httpRequest"
          :show-file-list="false"
        >
          <svg-icon iconClass="upload" className="icon" />
          <p class="p1">拖拽你的文件到此处</p>
          <p class="p2">或</p>
          <div class="btn">点击上传</div>
        </el-upload>
      </div>
      <div v-show="file" class="fileLists">
        <div :style="{'visibility':file && file.name ? 'visible' : 'hidden'}" class="item-upload-area">
          <div>
            <img src="@/assets/images/const/xlsx.png" />
            <div class="des">
              <p class="fileName">{{ file && file.name }}</p>
              <p class="fileSize">{{ file && file.size | formatSize }} mb</p>
            </div>
          </div>
          <i class="el-icon-circle-check"></i>
        </div>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-loading="loading" class="ok flex_c_c" @click="ok">确定</div>
    </span>
  </el-dialog>
</template>

<script>
import { uploadOwerISA } from '@/api/bill'
export default {
  filters: {
    formatSize(size) {
      return (size / 1024 / 1024).toFixed(2)
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    PODId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileList: [],
      file: null,
      loading: false
    }
  },
  methods: {
    cancel() {
      this.file = null
      this.$emit('cancel')
    },
    async ok() {
      this.loading = true
      try {
        const formData = new FormData()
        formData.set('file', this.file)
        const res = await uploadOwerISA(formData, this.PODId)
        this.loading = false
        if (res.data.success) {
          this.$message.success('上传成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.data.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    httpRequest({ file }) {
      const suffix = file.name.slice(
        file.name.lastIndexOf('.') + 1,
        file.name.length
      )
      if (!(suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg' || suffix === 'pdf')) {
        this.$message.warning('请上传图片或PDF格式文件')
        return false
      }
      this.file = file
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 80px);
  margin: 0 auto;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & div {
    width: 120px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #999999;
    margin-right: 16px;
  }
  .ok {
    background:  rgb(18,88,188);
    color: #ffffff;
  }
}
.upload {
  width: 400px;
  height: 200px;
  background: #F7F7F7;
  border-radius: 6px 6px 6px 6px;
  border: 0;
  margin-top: 20px;
  .icon {
    font-size: 40px;
    margin: 26px auto 0;
    color:  rgb(18,88,188);
  }
  .p1, .p2 {
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    text-align: center;
    margin-top: 10px;
  }
  .btn {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid  rgb(18,88,188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    line-height: 40px;
    text-align: center;
    margin: 10px auto 0;
    box-sizing: border-box;
  }
  /deep/ .upload-demo {
    width: 100%;
    height: 100%;
  }
  /deep/.el-upload {
    width: 100%;
    height: 100%;
  }
  /deep/.el-upload-dragger {
    width: 100%;
    height: 100%;
  }
  /deep/.el-upload-dragger {
    background: #F7F7F7;;
    border: 0;
  }
}
.fileLists {
    width: 400px;
    height: 64px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
    border-radius: 6px 6px 6px 6px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .icon {
      color: #b8c3de;
      line-height: 40px;
      cursor: pointer;
    }
    .file {
      display: flex;
    }
  }
.des {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin-left: 16px;
}
.fileName {
  width: auto;
  height: auto;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #25396f;
  line-height: 14px;
}
.fileSize {
  width: auto;
  margin-top: 5px;
  height: 16px;
  font-size: 12px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #7c8db5;
}
.item-upload-area {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    display: flex;
    align-items: center;
    height: 100%;
    img {
      width: 40px;
      height: 40px;
    }
  }
  i {
    font-size: 18px;
    color: #B8C3DE;
    cursor: pointer;
  }
}
.el-icon-circle-check {
  color: #35BA83 !important;
}
</style>
